import React, { useState } from "react";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  FormCaption,
  Breadcrumbs,
  Head,
  FormFooter,
  Card,
  ImagePicker,
  Input,
  RadioGroup,
  Switch,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock,
  StepTabs
} from "xsolla-uikit";

import {
  PAvCpreview,
  PAinfoCollapsible,
  CssVCimage,
  CssVCimages,
  CssSquareButton,
  CssThTd
} from "../uikit2";

import { PAskuName } from "../PAskuName";

import PAContentBlock from "../PAContentBlock";

import { vc, currDef, currencies, vcpacks, currs } from "../../data/vc";

export default function PAvcNew() {
  const [curName, setCurName] = useState(currDef['title']);

  const [step, setStep] = useState(0);

  const steps = [
    {
      label: "Currency",
      value: 0,
      onClick: () => setStep(0)
    },
    {
      label: "Set packages",
      value: 1,
      // disabled: true
      onClick: () => setStep(1)
    }
  ];

  return (
    <div>
      {/* <FormGroup indentation="lg">
      <StepTabs
        current={step}
        steps = {[...steps]}
      />
</FormGroup> */}

      <FormGroup indentation="lg">
        <PAskuName
          opened={true}
          handleInput={setCurName}
          label="Currency name"
          sku={{
            value: curName,
            shown: false
          }}
          name={{
            value: curName,
            languages: false,
            content: [curName, "Золотые монеты", "Алтын"]
          }}
        />
      </FormGroup>

      <FormGroup
        indentation="lg"
        label="Virtual currency thumbnail"
      >
        <FormCaption label={<PAvCpreview
            {...currDef}
            // amount="1"
          />}>
          <ImagePicker
            appearance="secondary"
            // style={{width: 64, height: 64}}
            name="image2"
            input={{
              value:
                "//cdn3.xsolla.com/img/misc/images/40a074e3b025cb56b8bb630da6989481.png"
              // onChange: () => this.setState({value: null})
            }}
            url="/"
          />
        </FormCaption>
      </FormGroup>

      {/* <FormGroup label="Preview" indentation="lg">
        <div style={{fontWeight: 600}}>
          <PAvCpreview
            {...currDef}
            // image_url="\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png"
            amount="500"
          />
        </div>
      </FormGroup> */}

      <FormGroup indentation="lg" label="Price of currency in other currencies">
        <br />

        {Object.keys(currs).map((oneCurrId, i) => {
          let oneCurr = currs[oneCurrId];
          return (
            <FormGroup indentation="sm">

                {/* {oneCurrId === "USD" && (
                  <FormGroup indentation="sm">
                    <Switch
                      name="switch_1"
                      // label="Subscription renewal notification"
                      sublabel="Price in real currency"
                      tooltip="Currency can be sold in"
                      input={{
                        value: true,
                        onChange: () => {
                          void 0;
                        }
                      }}
                    />
                </FormGroup>)} */}

                <div
                  key={`curr_${i}`}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 0.2fr 2fr",
                    gridColumnGap: "16px"
                  }}
                >

                    <PAvCpreview {...currDef} amount={1} />

                    <div style={{display: 'flex', alignItems:'center'}}>
                      =
                    </div>


                  <Input
                    size="sm"
                    input={{
                      // name: 'with-icon',
                      value: ""
                      // onChange: this.handleInput
                    }}
                    extra={
                      oneCurr["image_url"] ? (
                        <PAvCpreview {...oneCurr} amount={2} number={false} />
                      ) : (
                        "USD"
                      )
                    }
                    offset="right"
                  />
                </div>
              </FormGroup>

          );
        })}
      </FormGroup>

      <FormFooter sticky={true}>
        <Button appearance="outline">Discard</Button>

        <Button type="submit">Save changes</Button>
      </FormFooter>
    </div>
  );
}
